<template>
    <a class="w-sharing" :href="sharelink" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.6 481.6" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M381.6 309.4c-27.7 0-52.4 13.2-68.2 33.6l-132.3-73.9c3.1-8.9 4.8-18.5 4.8-28.4 0-10-1.7-19.5-4.9-28.5l132.2-73.8c15.7 20.5 40.5 33.8 68.3 33.8 47.4 0 86.1-38.6 86.1-86.1S429 0 381.5 0s-86.1 38.6-86.1 86.1c0 10 1.7 19.6 4.9 28.5l-132.1 73.8c-15.7-20.6-40.5-33.8-68.3-33.8-47.4 0-86.1 38.6-86.1 86.1s38.7 86.1 86.2 86.1c27.8 0 52.6-13.3 68.4-33.9l132.2 73.9c-3.2 9-5 18.7-5 28.7 0 47.4 38.6 86.1 86.1 86.1s86.1-38.6 86.1-86.1-38.7-86.1-86.2-86.1zm0-282.3c32.6 0 59.1 26.5 59.1 59.1s-26.5 59.1-59.1 59.1-59.1-26.5-59.1-59.1 26.6-59.1 59.1-59.1zM100 299.8c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.6 59.1-59.1 59.1zm281.6 154.7c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.5 59.1-59.1 59.1z"/></svg>
        <!-- <i class="el-icon-position"></i> -->
        <span class="u-text">分享</span>
    </a>
</template>

<script>
import { __imgPath } from "@jx3box/jx3box-common/data/jx3box.json";
export default {
    name: "Sharing",
    props: ["title", "pic", "url", "simple"],
    data: function() {
        return {
            api: "https://service.weibo.com/share/share.php?",
        };
    },
    computed: {
        url_: function() {
            return (
                this.url ||
                location.origin + location.pathname + location.search
            );
        },
        title_: function() {
            return this.title || document.title;
        },
        pic_: function() {
            return this.pic || __imgPath + `image/common/logo.png`;
        },
        sharelink: function() {
            return (
                this.api +
                `url=${this.url_}` +
                `&title=${this.title_}` +
                `&pic=${this.pic_}`
            );
        },
    },
    methods: {},
    mounted: function() {},
    components: {},
};
</script>

<style lang="less">
@import "../../assets/css/sharing.less";
</style>
